class House {
  constructor(houseData) {
    this._id = houseData.id;
    this._roomsWithRelation = new Map(); // [roomId, ParentRoom | ChildRoom]>
    this._roomsCount = 0;
    this._excludedRoomIds = new Set();
    this._payload = houseData;
  }

  get id() {
    return this._id;
  }

  get roomsWithRelation() {
    return this._roomsWithRelation;
  }

  get roomsCount() {
    return this._roomsCount;
  }

  get excludedRoomIds() {
    return this._excludedRoomIds;
  }

  get payload() {
    return this._payload;
  }

  exclude(roomId) {
    const nextValue = new Set(this._excludedRoomIds);
    nextValue.add(roomId);
    this._excludedRoomIds = nextValue;
  }

  include(roomId) {
    this._excludedRoomIds.delete(roomId);
    const nextValue = new Set(this._excludedRoomIds);
    this._excludedRoomIds = nextValue;
  }

  setRoomsCount(count) {
    this._roomsCount = count || 0;
  }
}

export default House;
